<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <div class="title-container">
            <h3 class="title">
              Items Management
              <div
                class="spinner-border spinner-theme_default"
                role="status"
                v-if="isDataPageLoading"
              >
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </h3>
            <div class="title-container__controls">
              <b-button
                v-if="$can(permissions.CreateFinancesProjectSpecialisations)"
                variant="success"
                class="button"
                @click="showCreateInvoicesModal"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </div>
          </div>

          <TableForPage
            v-if="getSpecialisations.length"
            :tableData="getSpecialisations"
            :fields="invoiceFields"
            :isRemove="$can(permissions.DeleteFinancesProjectSpecialisations)"
            :isEdit="$can(permissions.UpdateAllFinancesProjectSpecialisations)"
            @edit="showEditInvoicesModal"
            @remove="removeProjectSpecialisation"
          />
        </div>
      </div>
    </div>
    <b-modal
      size="md"
      hide-footer
      v-model="createSpecialisationModal.show"
      class="modal"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{createSpecialisationModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FinancesProjectSpecialisationForm @submit="createProjectSpecialisation" />
    </b-modal>
    <b-modal
      size="md"
      hide-footer
      v-model="editSpecialisationModal.show"
      :title="editSpecialisationModal.title"
      class="modal"
    >
      <FinancesProjectSpecialisationForm
        :formData="editSpecialisationModal.formData"
        :submitButtonText="editSpecialisationModal.submitButtonText"
        @submit="editProjectSpecialisation"
      />
    </b-modal>
  </div>
</template>

<script>
import { permissions } from '@mocks/permissions'
import FinancesProjectSpecialisationForm from '@forms/FinancesProjectSpecialisationForm'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'

export default {
  name: 'FinancesProjectSpecialisation',
  components: {
    FinancesProjectSpecialisationForm,
    TableForPage
  },
  data () {
    return {
      permissions: permissions,
      createSpecialisationModal: {
        show: false,
        title: 'Create project specialisation'
      },
      editSpecialisationModal: {
        show: false,
        title: 'Edit project specialisation',
        submitButtonText: 'Edit',
        formData: null
      },
      invoiceFields: [
        {
          key: 'id',
          label: 'Id'
        },
        {
          key: 'type_display_name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'type_name',
          label: 'Type',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          class: 'action_column'
        }
      ],
      isDataPageLoading: false
    }
  },
  created () {
    this.fetchInvoiceProjectSpecialisations()
  },
  computed: {
    ...mapGetters({
      getSpecialisations: 'finances/getSpecialisations'
    }),
    getTotalSpecialisation () {
      return this.getSpecialisations.length
    }
  },
  methods: {
    showCreateInvoicesModal () {
      this.createSpecialisationModal.show = true
    },
    hideCreateInvoicesModal () {
      this.createSpecialisationModal.show = false
    },
    showEditInvoicesModal (params) {
      this.editSpecialisationModal.show = true
      this.setParamsForEditInvoicesModal(params)
    },
    hideEditInvoicesModal () {
      this.editSpecialisationModal.show = false
    },
    setParamsForEditInvoicesModal (params) {
      this.editSpecialisationModal.formData = params
    },

    fetchInvoiceProjectSpecialisations () {
      if (this.getTotalSpecialisation) return

      this._toggleDataPageLoading(() => this.$api.finances.getInvoiceProjectSpecialisations())
    },
    createProjectSpecialisation (data) {
      this.hideCreateInvoicesModal()
      this._toggleDataPageLoading(() => this.$api.finances.createInvoiceProjectSpecialisations(data))
    },
    editProjectSpecialisation (data) {
      this.hideEditInvoicesModal()
      this._toggleDataPageLoading(() => this.$api.finances.editInvoiceProjectSpecialisations(data))
    },
    async removeProjectSpecialisation (data) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the project specialisation ?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(() => this.$api.finances.removeInvoiceProjectSpecialisations(data.id))
    }
  }
}
</script>
